// extracted by mini-css-extract-plugin
export default {"placeholder":"editor_placeholder__yiYZK","container":"editor_container__BRib9","inputContainer":"editor_inputContainer__+Ag1q","buttonContainer":"editor_buttonContainer__+oWio"};